
import { Component, Input } from "@angular/core";
import { I18nModule } from "@spartacus/core";
import { Udxb2bAttraction, Udxb2bAttractionEvent } from "src/app/udxb2b/features/model";
import { UDXAppUtils } from "src/app/udxb2b/utilities/constants/udx-app.utils";

@Component({
    selector: 'udx-cx-attraction-event',
    templateUrl: './attraction-event.component.html',
    styleUrls: ['./attraction-card.component.scss'],
    standalone: true,
    imports: [I18nModule],
  })

export class AtractionEventComponent {
    @Input() product!: Udxb2bAttraction;
    @Input() shouldGroupProducts: boolean = false; // Will be used when subgroups need to have division
    @Input() key?: string;
    getImage(event: any) {
      if (event.tridionContent) {
        let resolvedObject = this.JSONParser(event.tridionContent);
        if (resolvedObject) {
          return resolvedObject.image[0].desktop;
        }
      }
      // return resolvedObject[0].image[0].desktop;
      return '/images/EXP_logo_480_240.jpg';
    }

    JSONParser(tridionContent: any): any {
      var json = undefined;
      if (tridionContent) {
        json = JSON.parse(tridionContent);
      }
      return json;
    }

    getAttractionEventsInSubgroupsForKey(inKey: string): Udxb2bAttractionEvent[][] {
        var subgroupAttractionEvents: Udxb2bAttractionEvent[][] = [];
        let uniqueSubgroups = [...new Set(this.product.attractions?.events?.filter((anEvent: Udxb2bAttractionEvent) => {
          return anEvent.maingroup === inKey;
        }).map((item: Udxb2bAttractionEvent) => item.subgroup))]
        if (uniqueSubgroups) {
          // alert ("Unique subgroup: " + JSON.stringify(uniqueSubgroups));
          uniqueSubgroups.forEach(aSubGroup => {
            let eventsInSubgroup = this.getAttractionEventsForKey(inKey, aSubGroup as string);
            if (eventsInSubgroup) {
                subgroupAttractionEvents.push(this.sortEventsByStartTimeAndLandEntry(eventsInSubgroup));
            }
          })
        }
        return subgroupAttractionEvents;
      }

    getAttractionEventsForKey(inKey: string, inSubgroup?:string): Udxb2bAttractionEvent[] | undefined {
      let anEvent = this.product.attractions?.events?.filter((anEvent: Udxb2bAttractionEvent) => {
          var qualified = false;
          if (anEvent.maingroup === inKey) {
          if (inSubgroup) {
              // Check this condition if only subGroup info is passed to this method
              if (anEvent.subgroup === inSubgroup) {
                qualified = true;
              }
              } else {
                  qualified = true;
              }
          }
          return qualified;
      });
      return anEvent;
    }

    isAttractionGroupChoice(subGroupEvents: Udxb2bAttractionEvent[]): boolean {
      return UDXAppUtils.isAttractionGroupChoice(subGroupEvents);
    }
    getOnlyChoiceText(subGroupEvents: Udxb2bAttractionEvent[]): string {
      return UDXAppUtils.getOnlyChoiceText(subGroupEvents);
    }
    sortEventsByStartTimeAndLandEntry(events: Udxb2bAttractionEvent[]): Udxb2bAttractionEvent[] {
      return UDXAppUtils.sortEventsByStartTimeAndLandEntry(events);
    }
    getCountOfAttractionGroupChoice() {
      let eventsInSubgroupByKey: Udxb2bAttractionEvent[][] = this.getAttractionEventsInSubgroupsForKey(this.key!);
      var countOfChoiceGroups = 0;
      for (let aSubgroup in eventsInSubgroupByKey) {
        if (this.isAttractionGroupChoice(eventsInSubgroupByKey[aSubgroup])) {
          countOfChoiceGroups++;
        }
      }
      return countOfChoiceGroups;
    }
}
